import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import { useAuth } from "../../context/Auth";
import { useDomainCheck } from "../../lib/hooks/useDomainCheck";
import CenterParcsVerify2fa from "./CenterParcsVerify2fa";
import DefaultVerify2fa from "./DefaultVerify2fa";

const Verify2fa = React.memo(() => {
  const [code, setCode] = useState("");

  const { t } = useTranslation(["login", "common"]);

  const { verify2fa } = useAuth();

  const { isCenterParcsDomain } = useDomainCheck();

  const { state } = useLocation<{ token?: string }>();

  const token = state?.token ?? "";

  const onSubmit = useCallback(
    (e: any) => {
      e.preventDefault();

      return verify2fa({ code, token }).catch((error) => {
        toast.error<string>(
          error?.networkError?.result?.errors?.[0]?.message ?? error?.message,
        );
      });
    },
    [code, token, verify2fa],
  );

  if (!token) {
    return <Redirect to="/login" />;
  }

  const verify2faProps = {
    code,
    setCode,
    onSubmit,
    t,
  };

  if (isCenterParcsDomain) {
    return <CenterParcsVerify2fa {...verify2faProps} />;
  }

  return <DefaultVerify2fa {...verify2faProps} />;
});

export default Verify2fa;
